import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlarmAdd = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <g id="Design-System">
        <g id="Design-System---Icons" transform="translate(-652.000000, -1222.000000)">
          <g id="Component/Icons/Normal/16px/Alarm-Add" transform="translate(652.000000, 1222.000000)">
            <path
              d="M8,0.000245259046 C8.31751839,0.00216322717 8.63418674,0.0332944711 8.946,0.093245259 C7.84665727,1.61275379 7.69320244,3.62070167 8.5488738,5.28961963 C9.40454515,6.95853758 11.1245193,8.00595923 13,8.00024526 C13.0789772,9.16052396 13.6191634,10.2408963 14.5,11.0002453 L14.5,11.0002453 L15,11.0002453 C15.5522847,11.0002453 16,11.4479605 16,12.0002453 C16,12.55253 15.5522847,13.0002453 15,13.0002453 L15,13.0002453 L1,13.0002453 C0.44771525,13.0002453 0,12.55253 0,12.0002453 C0,11.4479605 0.44771525,11.0002453 1,11.0002453 L1,11.0002453 L1.5,11.0002453 C2.38083664,10.2408963 2.9210228,9.16052396 3,8.00024526 L3,8.00024526 L3,5.00024526 C2.98676962,3.67015101 3.50930422,2.39067986 4.44986941,1.45011467 C5.39043461,0.509549482 6.66990575,-0.0129851217 8,0.000245259046 Z M14,0.000245259046 L14,2.00024526 L16,2.00024526 L16,4.00024526 L14,4.00024526 L14,6.00024526 L12,6.00024526 L12,4.00024526 L10,4.00024526 L10,2.00024526 L12,2.00024526 L12,0.000245259046 L14,0.000245259046 Z M10,14.0002453 L6,14.0002453 C6,15.1048148 6.8954305,16.0002453 8,16.0002453 C9.1045695,16.0002453 10,15.1048148 10,14.0002453 Z"
              id="Alarm-Add"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

AlarmAdd.displayName = 'AlarmAdd';
